import { ViewportScroller } from '@angular/common';
import { Component, ElementRef, HostListener, NgZone } from '@angular/core';

@Component({
  selector: 'app-politica-privacidade',
  templateUrl: './politica-privacidade.component.html',
  styleUrls: ['./politica-privacidade.component.scss']
})
export class PoliticaPrivacidadeComponent {
  showScrollButton = false;

  public year = new Date().getFullYear();

  constructor(
    private el: ElementRef,
    private viewportScroller: ViewportScroller,
    private ngZone: NgZone,
  ) {
  }

  @HostListener('window:scroll', [])

  onWindowScroll() {
    const sectionToReach = document.getElementById('banner');
    if (!sectionToReach) {
      return;
    }

    const scrollPosition = this.viewportScroller.getScrollPosition()[1];
    const sectionPosition = sectionToReach.offsetTop;

    this.showScrollButton = scrollPosition > sectionPosition;
  }

  scrollToTop() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }
}
